import { toRadian } from '@bhb-frontend/toolbox';
/**
 * 2d 向量
 */
export class Vector2d {
  x: number;

  y: number;

  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }

  /** 若b为单位矢量，则a与b的点积即为a在方向b的投影 */
  sub(v: Vector2d) {
    return new Vector2d(this.x - v.x, this.y - v.y);
  }

  /** 向量点积 */
  dot(v: Vector2d) {
    return this.x * v.x + this.y * v.y;
  }
}

/**
 * obb 碰撞
 **/
export class OBB {
  /** 宽 */
  width: number;

  /** 高 */
  height: number;

  /** 弧度 */
  radian: number;

  /** 范围 */
  extents: [number, number];

  /** 旋转轴 */
  axes: [Vector2d, Vector2d];

  /** 中心点 */
  centerPoint: Vector2d;

  constructor(
    centerPoint: Vector2d,
    width: number,
    height: number,
    rotate = 0
  ) {
    this.radian = toRadian(rotate);
    this.centerPoint = centerPoint;
    this.extents = [width / 2, height / 2];
    this.axes = [
      new Vector2d(Math.cos(this.radian), Math.sin(this.radian)),
      new Vector2d(-1 * Math.sin(this.radian), Math.cos(this.radian)),
    ];
    this.width = width;
    this.height = height;
  }

  /** 获取投影半径 */
  getProjectionRadius(axis: Vector2d) {
    return (
      this.extents[0] * Math.abs(axis.dot(this.axes[0])) +
      this.extents[1] * Math.abs(axis.dot(this.axes[1]))
    );
  }
}

/**
 * 检测两矩形是否发生碰撞
 **/
export function isCollision(rect1: OBB, rect2: OBB) {
  const nv = rect1.centerPoint.sub(rect2.centerPoint);
  const axisA1 = rect1.axes[0];
  if (
    rect1.getProjectionRadius(axisA1) + rect2.getProjectionRadius(axisA1) <=
    Math.abs(nv.dot(axisA1))
  )
    return false;

  const axisA2 = rect1.axes[1];
  if (
    rect1.getProjectionRadius(axisA2) + rect2.getProjectionRadius(axisA2) <=
    Math.abs(nv.dot(axisA2))
  )
    return false;

  const axisB1 = rect2.axes[0];
  if (
    rect1.getProjectionRadius(axisB1) + rect2.getProjectionRadius(axisB1) <=
    Math.abs(nv.dot(axisB1))
  )
    return false;

  const axisB2 = rect2.axes[1];
  if (
    rect1.getProjectionRadius(axisB2) + rect2.getProjectionRadius(axisB2) <=
    Math.abs(nv.dot(axisB2))
  )
    return false;
  return true;
}
